import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class DataListPromotionService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    public GetAll(query: string) {
        return this.baseApiFactory.get<any[]>('/api/DataListPromotion?' + query);
    }

    public Detail(id) {
        return this.baseApiFactory.get('/api/DataListPromotion/' + id);
    }

    public Add(data: any) {
        return this.baseApiFactory.post('/api/DataListPromotion/Add', data);
    }

    public Update(data: any) {
        return this.baseApiFactory.put('/api/DataListPromotion/Update', data);
    }
}

lazyRegister.service('DataListPromotionService', DataListPromotionService);

